import styled, { css } from 'styled-components';

import { ListWrapper } from 'common/ListStyles';
import { SummaryIcons } from '../../../reporting/pages/summary/Styles';
import { FlexDiv, GenericSpan } from 'commonStyles';

import { ASSET_PATH } from 'assetsPath';

export const ListingWrapper = styled(ListWrapper)`
	border-color: #d8d8d8;
	border-radius: 16px;
	padding: 16px 20px 24px;
	overflow: hidden;

	& > div {
		overflow-x: hidden;
	}

	& table {
		table-layout: fixed;
		word-break: break-word;
	}

	& .report_cell_head {
		font-style: normal;
		font-weight: 900;
		font-size: 12px;
		line-height: 16px;
		text-transform: uppercase;
		color: #757575;
		border-bottom: 1px solid #d8d8d8;
	}

	& .report_table {
		box-shadow: none;
		background: #fff;
		position: relative;
	}

	& .report_cell {
		font-size: 14px;
		line-height: 20px;
		color: #000;
		font-weight: 400;
		border-bottom: none;
	}

	& tr.report_table > td {
		border-bottom: none;
		background-color: #fff;

		&:first-child {
			border-top-left-radius: 16px;
			border-bottom-left-radius: 16px;
		}

		&:last-child {
			border-top-right-radius: 16px;
			border-bottom-right-radius: 16px;
		}
	}

	& .action-icon-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		font-size: 14px;
		line-height: 1;
	}
`;

export const LobIcons = styled(SummaryIcons) `
background-size: 200px 200px;
${(props) => {
		switch (props.icon) {
			case 'flt':
				return css`
				background-position: -1px -77px;
				width: 24px;
				height: 15px;`;
			case 'htl':
				return css`
				background-position: -41px -74px;
				width: 20px;
				height: 21px;`;
			case 'ic_bus':
				return css`
				background-position: -171px -70px;
				width: 15px;
				height: 15px;
 `;
			case 'ic_cab':
				return css`
				background-position: -171px -85px;
				width: 18px;
				height: 16px;`;
			case 'ic_requisition':
				return css`
				background-position: -175px -171px;
				width: 31px;
				height: 23px;`;
			case 'ic_train':
				return css`
				background-size: 250px 250px;
				background-position: -97px -78px;
				width: 24px;
				height: 24px;`;
			default:
				return css`
				background-position: -41px -74px;
				width: 20px;
				height: 21px;`;
		}
	}}
`;

export const FlightLegSide = styled(FlexDiv)`
	flex: 1 1 0;
	min-width: 0;
`;

export const ApprovalIcons = styled(GenericSpan) `
    background: url(${ASSET_PATH.IMAGES}managebookings/approvalicons.png) no-repeat;
  	background-size: 500px 500px; 
    display: inline-block;
		width: 28px;
		height: 28px;
		cursor: pointer;
    ${(props) => {
		switch (props.icon) {
			case 'viewDetails':
				return css`
				background-position: -5px -157px;
			`;
			case 'disabled_viewDetails':
				return css`
				background-position: -5px -157px;
				cursor: not-allowed;
				`;
			case 'approve':
				return css`
				background-position: -5px -122px;
				`;
			case 'reject':
				return css`
				background-position: -5px -86px;
				`;
			case 'modify':
				return css`
				background-position: -6px -51px;
				`;
			case 'download':
				return css`
				background-position: -5px -192px;
				`;
			case 'info':
				return css`
				background-position: -28px -27px;
				width: 10px;
				height: 10px;`;
			case 'flightInfo':
				return css`
				background-position: -8px -22px;
				width: 16px;
				height: 16px;
				margin-left: 4px;`;
			case 'disabled_modify':
				return css`
				background-position: -6px -227px;
				cursor: not-allowed;
				`;
			default:
				return css`
				background-position: -41px -74px;
				`;
		}
	}}
`;
